import { SHOW_AWARD, HIDE_AWARD, SET_CURRENT_CARD } from '../types/award';

export const showAward = () => ({ type: SHOW_AWARD });
export const hideAward = () => ({ type: HIDE_AWARD });
export const setCurrentCard = data => ({ type: SET_CURRENT_CARD, payload: data });
